module.exports = __webpack_public_path__ + "static/media/IMG_2996.6fef4f95.jpg";